<template>
  <nav class="grey lighten-1" role="navigation" id="nav">
    <div class="nav-wrapper container">
      <a id="logo-container" href="#" class="brand-logo">
        <img
          alt="Vue logo"
          class="responsive-img"
          width="90"
          style="margin-top:6px;"
          src="../assets/logo.png"
        />
      </a>
      <ul class="right hide-on-med-and-down">
        <li>
          <router-link class="menu" to="/">
            Processos
          </router-link>
        </li>
        <li>
          <router-link class="menu" to="/distritos">
            Distritos
          </router-link>
        </li>

        <li class="valign-wrapper">
          <a class="menu">Última Atualização: {{ time }}</a>
        </li>
      </ul>

      <ul id="nav-mobile" class="sidenav">
        <li>
          <router-link class="menu" to="/">
            Processos
          </router-link>
        </li>
        <li>
          <router-link class="menu" to="/distritos">
            Distritos
          </router-link>
        </li>
      </ul>
      <a href="#" data-target="nav-mobile" class="sidenav-trigger">
        <i class="material-icons lighten-1">menu</i>
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav",
  computed: {
    time() {
      return this.$store.getters.getTime;
      // return window.localStorage.getItem("cacheTime");
    }
  }
};
</script>

<style>
.menu {
  color: rgb(1, 81, 98);
  font-size: 20px;
  font-weight: bold;
}
nav {
  width: 1920px !important;
  background-color: #bdbdbd !important;
}
</style>
